<template>
  <div class="post-card" :target="blok.target">
    <div class="post-card__image" :style="imageStyle" />
    <div class="post-card__content" :style="contentStyle">
      <StoryblokComponent
        v-for="childBlok in blok.blocks"
        :key="childBlok._uid"
        :blok="childBlok"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { SbPostCardStoryblok } from '@/types'

interface Props {
  blok: SbPostCardStoryblok
}
const props = defineProps<Props>()
const imageStyle = computed(() => {
  const paddingTop = `${props.blok.image_ratio || 40}%`
  const backgroundImage = `url(${props.blok.image?.filename || '/'})`

  return {
    backgroundImage,
    paddingTop,
  }
})

const contentStyle = computed(() => {
  const padding = props.blok.padding === 'small' ? '32px' : '40px 48px'

  return {
    padding,
  }
})
</script>

<style lang="scss" scoped>
.post-card {
  display: block;
  width: 100%;

  &__image {
    background-position: center center;
    background-size: cover;
  }

  &__content {
    padding: 40px 48px;
  }
}
</style>
